module.exports = __webpack_public_path__ + "static/media/BelmontTrain.d088b729.png";